// extracted by mini-css-extract-plugin
export default {"dateCenterCont":"date-center_dateCenterCont__KAsHs"};